import React, { lazy, Suspense } from 'react'

import { useSearchParams } from 'react-router-dom'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'
import PageHeader from 'components/PageLayout/PageHeader'
import styles from './style.module.css'
import { lang } from './lang'
import PageLayout from '~components/PageLayout'
import { QueryParams } from '~constants/routes'
import SendReceiveWidgetSkeleton from '~components/SendWidget/Skeleton'
import { SendReceiveInitialTab } from '~types'

const ReceiveWidget = lazy(() => import('~components/ReceiveWidget'))

function ReceivePage() {
    const [searchParams] = useSearchParams()

    const initialTab = (searchParams.get(QueryParams.type) as SendReceiveInitialTab) || ''
    const initialCurrency = searchParams.get(QueryParams.fromCurrency) || ''

    return (
        <Suspense
            fallback={
                <PageLayout
                    contentWidth="m"
                    header={
                        <PageHeader
                            rootPage={false}
                            title={<FormattedHTMLMessage {...lang.title} values={{ currency: '' }} />}
                        />
                    }
                >
                    <div className={styles.wrap}>
                        <SendReceiveWidgetSkeleton type="receive" initialTab={initialTab} />
                    </div>
                </PageLayout>
            }
        >
            <ReceiveWidget initialTab={initialTab} initialCurrency={initialCurrency} />
        </Suspense>
    )
}

export default ReceivePage
